import { useState } from 'react';

const faqs = [
  {
    q: 'Q1. 싱크대·주방가구 교체 비용은 얼마인가요?',
    a: '주방 크기와 구성에 따라 다르지만, 대구싱크대 키친스는 현장 경험 기반의 정확한 견적 시스템으로 방문 전 온라인 견적을 먼저 제공합니다. 사진 한 장으로 바로 확인해보세요.',
  },
  {
    q: 'Q2. 대구·경북 외 지역도 시공 가능한가요?',
    a: '현재는 대구 및 경북 지역 한정으로 운영 중입니다. 해당 지역 외 문의는 카카오톡으로 연락 주시면 안내해 드리겠습니다.',
  },
  {
    q: 'Q3. 견적까지 얼마나 걸리나요?',
    a: '온라인 신청 후 영업일 기준 1~2일 이내 디자인과 견적을 받아볼 수 있습니다.',
  },
  {
    q: 'Q4. 살면서 시공이 가능한가요?',
    a: '네, 가능합니다. 시공은 보통 1~3일 소요되며, 주변 공간을 충분히 보양한 후 진행되어 생활 불편을 최소화합니다.',
  },
  {
    q: 'Q5. 시공 후 AS는 어떻게 되나요?',
    a: '계약일로부터 1년간 무상 유지보수를 보장합니다. 대구·경북 지역 밀착 서비스로 빠른 AS 대응이 가능합니다.',
  },
  {
    q: 'Q6. 방문 상담 예약은 어떻게 하나요?',
    a: '010-4016-8890으로 사전 방문 상담 예약이 가능합니다. 대구 지역 쇼룸에서 직접 자재와 디자인을 확인하실 수 있습니다.',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="w-full bg-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">FAQ</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                className="w-full text-left px-6 py-5 flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <span className="text-sm font-semibold text-gray-900">{item.q}</span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-3">
                  <i className={`text-gray-500 transition-transform duration-200 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-600 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
